import { useEffect, useState } from 'react';
import { Dropdown, DropdownChangeEvent, SCIcon } from '../../Common/Imports';
import { ContactType } from '../../Models/Enums';
import { DDModel } from '../../Models/Classes';


interface DDContactsTypeProps {
    value?: ContactType;
    onSelect?: (contact: ContactType | undefined) => void;
    onBlur?: () => void;
}

export const DDContactType: React.FC<DDContactsTypeProps> = ({ value, onSelect, onBlur }) => {
    const [data] = useState<DDModel<number>[]>([
        { label: "Mail", id: 1, data: 1, icon: "Mail" },
        { label: "Phone", id: 0, data: 0, icon: "Phone" }
    ]);

    const [selectedElem, setSelectedElem] = useState<DDModel<ContactType>>(data.find(d => d.data === value) || data[0]);

    useEffect(() => {
        // Update state when external value changes
        const newSelection = data.find(d => d.data === value);
        if (newSelection) {
            setSelectedElem(newSelection);
        }
    }, [data, value]);

    const handleChange = (e: DropdownChangeEvent) => {
        const _val = e.value as DDModel<ContactType>;
        setSelectedElem(_val);
        if (onSelect) {
            onSelect(_val.data);
        }
    };

    return (
        <Dropdown
            value={selectedElem}
            onChange={handleChange}
            options={data}
            optionLabel="label"
            onBlur={onBlur}  
            itemTemplate={(d) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <SCIcon Name={d.icon ?? ""} Classes="pr-3" />
                    {d.label}
                </div>
            )}
        />
    );
};

